import React, { useContext, useState, useEffect } from "react";
import { CrackersContext } from "../CrackersContext";

export function useCrackersCategories() {
  const { crackersCategory, setCrackersCategory } = useContext(CrackersContext);
  const [category, setCategory] = useState(crackersCategory || []);
  const [loading, setLoading] = useState(!crackersCategory.length);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (crackersCategory.length > 0) {
      setLoading(false);
      return;
    }

    async function fetchCategories  () {
      try {
        const response = await fetch("/v1/crackers/categories");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setCategory(data);
        setCrackersCategory(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    }

    fetchCategories ();
  }, [crackersCategory, setCrackersCategory]);

  return { category, loading, error };
}
